/**
 * FIX-FIN A1: o percentual digitado escrito por extenso, para a confirmação antes de propor uma alíquota de
 * retenção ("0,65" → "zero vírgula sessenta e cinco por cento"). Só lê o TEXTO digitado — não converte nem calcula
 * (a fração é feita no backend). Aceita vírgula ou ponto; inteiro até 999 e até 4 casas decimais. Fora disso → null.
 */

const UNIDADES = ['zero', 'um', 'dois', 'três', 'quatro', 'cinco', 'seis', 'sete', 'oito', 'nove']
const DEZ_A_DEZENOVE = [
  'dez', 'onze', 'doze', 'treze', 'catorze', 'quinze', 'dezesseis', 'dezessete', 'dezoito', 'dezenove',
]
const DEZENAS = ['', '', 'vinte', 'trinta', 'quarenta', 'cinquenta', 'sessenta', 'setenta', 'oitenta', 'noventa']
const CENTENAS = [
  '', 'cento', 'duzentos', 'trezentos', 'quatrocentos', 'quinhentos', 'seiscentos', 'setecentos', 'oitocentos',
  'novecentos',
]

/** Inteiro de 0 a 9999 por extenso. */
export const inteiroPorExtenso = (n: number): string => {
  if (n < 10) return UNIDADES[n]
  if (n < 20) return DEZ_A_DEZENOVE[n - 10]
  if (n < 100) {
    const d = Math.floor(n / 10)
    const u = n % 10
    return u ? `${DEZENAS[d]} e ${UNIDADES[u]}` : DEZENAS[d]
  }
  if (n === 100) return 'cem'
  if (n < 1000) {
    const c = Math.floor(n / 100)
    const resto = n % 100
    return resto ? `${CENTENAS[c]} e ${inteiroPorExtenso(resto)}` : CENTENAS[c]
  }
  const m = Math.floor(n / 1000)
  const resto = n % 1000
  const milhar = m === 1 ? 'mil' : `${UNIDADES[m]} mil`
  if (!resto) return milhar
  return resto < 100 || resto % 100 === 0 ? `${milhar} e ${inteiroPorExtenso(resto)}` : `${milhar} ${inteiroPorExtenso(resto)}`
}

/** Texto digitado ("0,65") → "zero vírgula sessenta e cinco por cento"; inválido → null. */
export const percentualPorExtenso = (texto: string): string | null => {
  const t = texto.trim().replace('.', ',')
  const m = /^(\d{1,3})(?:,(\d{1,4}))?$/.exec(t)
  if (!m) return null
  const inteiro = inteiroPorExtenso(Number(m[1]))
  const decimais = (m[2] ?? '').replace(/0+$/, '')
  if (!decimais) return `${inteiro} por cento`
  // Zeros à esquerda da parte decimal são lidos um a um ("0,065" → "zero vírgula zero sessenta e cinco").
  const zeros = /^0*/.exec(decimais)?.[0].length ?? 0
  const partes = [...Array(zeros).fill('zero'), inteiroPorExtenso(Number(decimais.slice(zeros)))]
  return `${inteiro} vírgula ${partes.join(' ')} por cento`
}
